import { PROJECT_TRACK_URL } from "api/routes";
import { noAuthInstance } from "hooks/useRequest/helper";
import { IApiRequestDataWithId, IServerResponse } from "rules/interface/api/response";
import ITrackProject from "rules/interface/project/track.interface";




export const trackProject = async (data: IApiRequestDataWithId<ITrackProject>): Promise<IServerResponse<{}>> => {
    return await noAuthInstance.put(PROJECT_TRACK_URL + "/" + data.id, {
        ...data.data
    }).then(res => res.data)
}